import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { UserPreferencesEffects } from './user-preferences.effects';
import { reducer, userPreferencesFeatureKey } from './user-preferences.reducer';

@NgModule({
   imports: [
      StoreModule.forFeature(userPreferencesFeatureKey, reducer),
      EffectsModule.forFeature([UserPreferencesEffects]),
   ],
})
export class UserPreferencesModule {}
